import script from "./potentialDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./potentialDetail.vue?vue&type=script&setup=true&lang=ts"

import "./potentialDetail.vue?vue&type=style&index=0&id=312421c6&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-312421c6"]])

export default __exports__